import React, { Fragment, useEffect, useReducer, useRef } from 'react';
import { compose } from 'redux';
import moment from 'moment';
import { Row, Col } from 'antd';

import withClientId from 'hocs/with-client-id';
import { wsClient } from '@/index';

import { connect } from 'react-redux';
import * as actions from '@/redux/new_store_structure/actions';

import Timer from '@/pages/evacuation-demo/components/timer';
import EvacuationTopStatusBar from '@/pages/evacuation-demo/components/evacuation-top-status-bar';
import EvacuationZonesTable from '@/pages/evacuation-demo/components/evacuation-zone-table';
import EvacuationInfo from '@/pages/evacuation-demo/components/evacuation-info';
import EvacuationButton from '@/pages/evacuation-demo/components/evacuation-button';
import EvacuationSitesSelect from '@/pages/evacuation-demo/components/evacuation-sites-select';
import EvacuationReplaysSelect from '@/pages/evacuation-demo/components/evacuation-replay-select';
import EvacuationProgressBarEmployees from '@/pages/evacuation-demo/components/evacuation-progress-bar-employees';
import EvacuationPlayerBar from '@/pages/evacuation-demo/components/evacuation-player-bar';

import EvacuationSwitchersContainer from '@/pages/evacuation-demo/containers/evacuation-switchers-container';
import EvacuationZonesContainer from '@/pages/evacuation-demo/containers/evacuation-zones-container';

import './index.scss';

const speed = [1, 2, 4, 6];
const initialState = {
	zones: [],
	zonesOnStart: [],
	employeesStart: 0,
	employeesSave: 0,
	employeesRemaining: 0,
	evacuationProgress: 0,
	sec: 0,
	numbOfEmplArr: [],
	isEvacuationStarted: false,
	currentSpeed: 1,
	isPausedReplay: true,
	replayTimeline: {},
	type: 'evacuation',
	activeReplay: null,
	evacuationStartTime: null,
	sitesList: [],
	activeSiteId: null,
};

function reducer(state, action) {
	const { payload, type } = action;
	switch (type) {
		case 'getSiteList':
			return {
				...state,
				activeSiteId: payload.activeSiteId,
				sitesList: payload.sitesList,
			};
		case 'setActiveSite':
			return { ...state, activeSiteId: payload.activeSiteId };
		case 'setState':
			return { ...state, ...payload };
		default:
			throw new Error('unknown action type');
	}
}

function useInterval(callback, delay) {
	const savedCallback = useRef();

	// Remember the latest function.
	useEffect(
		() => {
			savedCallback.current = callback;
		},
		[callback],
	);

	// Set up the interval.
	useEffect(
		() => {
			function tick() {
				savedCallback.current();
			}
			if (delay !== null) {
				let id = setInterval(tick, delay);
				return () => clearInterval(id);
			}
		},
		[delay],
	);
}

function EvacuationDemoDashboard(props) {
	const [state, dispatch] = useReducer(reducer, initialState);

	// Emulate Player
	useInterval(
		() => {
			const { replayData } = props;
			// Your custom logic here
			const checkMax =
				state.sec + state.currentSpeed >= replayData.length - 1;
			const current = checkMax
				? replayData.length - 1
				: state.sec + state.currentSpeed;
			dispatch({
				type: 'setState',
				payload: {
					sec: current,
					isPausedReplay: checkMax && true,
					currentSpeed: checkMax ? 1 : state.currentSpeed,
				},
			});
		},
		!state.isPausedReplay ? (state.currentSpeed > 1 ? 500 : 1000) : null,
	);

	const calcReplay = () => {
		const { replayData } = props;
		if (replayData && replayData.length > 0) {
			const checkMax =
				state.sec + state.currentSpeed >= replayData.length - 1;
			const current = checkMax
				? replayData.length - 1
				: state.sec + state.currentSpeed;
			dispatch({
				type: 'setState',
				payload: {
					zones: replayData[current].evacuationStatsReportItems,
				},
			});
		}
	};

	// Effects
	// @ didmount unmount
	useEffect(() => {
		getListSites();
		return () => {
			stopEvacuationStats();
		};
	}, []);
	// get evac on sitelist change when evac is already run
	useEffect(
		() => {
			if (state.activeSiteId !== null) {
				getEvacuation();
			}
		},
		[state.sitesList],
	);
	// get list of replays
	useEffect(
		() => {
			if (state.activeSiteId !== null) {
				getListReplays();
			}
		},
		[state.activeSiteId],
	);
	// start evac when after choosed replay
	useEffect(
		() => {
			if (state.activeReplay !== null) {
				startEvacuationReplay();
			}
		},
		[state.activeReplay],
	);
	// calc zones if data changes
	useEffect(
		() => {
			if (state.zones !== null && state.type === 'replay') {
				calculateStatsFromZones(state.zones);
			}
		},
		[state.zones],
	);
	useEffect(
		() => {
			if (state.zones !== null && state.type === 'replay') {
				calcReplay();
			}
		},
		[state.sec, state.zones],
	);
	//initial replay data
	useEffect(
		() => {
			if (props.replayData.length > 0) {
				dispatch({
					type: 'setState',
					payload: {
						zonesOnStart:
							props.replayData[0].evacuationStatsReportItems,
						zones: props.replayData[0].evacuationStatsReportItems,
					},
				});
			}
		},
		[props.replayData],
	);
	// @EVACUATION RECORD
	const getListSites = () => {
		const { clientId } = props;

		const requestPayload = {
			messageType: 'core.site.list-sites',
			payload: {
				clientId,
			},
		};

		wsClient.request(requestPayload, response => {
			const { payload } = response;

			if (payload && Array.isArray(payload)) {
				dispatch({
					type: 'getSiteList',
					payload: {
						sitesList: payload,
						activeSiteId: payload[0].siteId,
					},
				});
				getEvacuation();
			}
		});
	};

	const changeSite = value => {
		stopEvacuationStats();
		dispatch({
			type: 'setState',
			payload: {
				activeSiteId: value,
				zonesOnStart: [],
			},
		});
		getEvacuation();
	};

	const stopEvacuationState = () => {
		dispatch({
			type: 'setState',
			payload: {
				isEvacuationStarted: false,
				evacuationStartTime: null,
				zonesOnStart: [],
			},
		});
		stopEvacuationStats();
	};

	const startEvacuationState = (startTime, zonesOnStart) => {
		dispatch({
			type: 'setState',
			payload: {
				isEvacuationStarted: true,
				evacuationStartTime: startTime,
				zonesOnStart: Array.isArray(zonesOnStart) ? zonesOnStart : [],
			},
		});
		startEvacuationStats();
	};

	const getEvacuation = () => {
		const { clientId } = props;
		const { activeSiteId: siteId } = state;
		if (siteId === null) return;

		const requestPayload = {
			messageType: 'evacuation.evacuation.get-evacuation',
			payload: {
				clientId,
				siteId,
			},
		};

		wsClient.request(requestPayload, response => {
			const { payload } = response;

			if (payload && payload.startTime) {
				if (payload.endTime) {
					stopEvacuationState();
				} else {
					const { startTime, initialStats } = payload;

					startEvacuationState(startTime, initialStats);
				}
			} else {
				stopEvacuationState();
			}
			getListReplays();
		});
	};

	const toggleEvacuation = () => {
		const { isEvacuationStarted, type } = state;
		if (type === 'replay') {
			// cut of unnecessary props
			const { activeSiteId, sitesList, ...resetState } = initialState;
			dispatch({
				type: 'setState',
				payload: {
					...resetState,
				},
			});
			return;
		}
		if (isEvacuationStarted) {
			fetchStopEvacuation();
		} else {
			fetchStartEvacuation();
		}
	};

	const fetchStartEvacuation = () => {
		const { activeSiteId } = state;
		const { clientId } = props;
		if (activeSiteId === null) return;
		const requestPayload = {
			messageType: 'evacuation.evacuation.start-evacuation',
			payload: {
				clientId,
				siteId: activeSiteId,
			},
		};

		wsClient.request(requestPayload, () => {
			getEvacuation();
		});
	};

	const fetchStopEvacuation = () => {
		const { activeSiteId } = state;
		const { clientId } = props;
		if (activeSiteId === null) return;

		const requestPayload = {
			messageType: 'evacuation.evacuation.end-evacuation',
			payload: {
				clientId,
				siteId: activeSiteId,
			},
		};

		wsClient.request(requestPayload, () => {
			getEvacuation();
		});
	};

	const startEvacuationStats = () => {
		const { activeSiteId } = state;
		const { clientId } = props;
		if (activeSiteId === null) return;

		const requestPayload = {
			messageType: 'evacuation.evacuation.subscribe-evacuation-stats',
			payload: {
				clientId,
				siteId: activeSiteId,
			},
		};

		wsClient.subscribe(requestPayload, response => {
			const { payload } = response;
			if (payload && Array.isArray(payload)) {
				calculateStatsFromZones(payload);
			}
		});
	};

	const stopEvacuationStats = () => {
		wsClient.clearAllCorrelations(
			'evacuation.evacuation.subscribe-evacuation-stats',
		);
	};

	//@ REPLAY
	const getListReplays = () => {
		const { activeSiteId: siteId } = state;
		if (siteId === null) return;
		const { clientId, getReplayList } = props;
		getReplayList({
			clientId,
			siteId,
		});
	};

	const startEvacuationReplay = () => {
		const { activeSiteId, activeReplay } = state;
		const { clientId, getReplayData } = props;
		getReplayData({
			clientId,
			siteId: activeSiteId,
			startTime: activeReplay,
		});
	};

	const onChangeReplayTime = sec => {
		dispatch({
			type: 'setState',
			payload: {
				sec: sec,
			},
		});
	};

	const changeReplay = value => {
		stopEvacuationStats();
		const { activeSiteId, sitesList, ...resetState } = initialState;
		dispatch({
			type: 'setState',
			payload: {
				...resetState,
			},
		});
		let replayTimeline = {};
		if (value) {
			const { replays } = props;
			const end = parseInt(
				moment(
					replays.filter(el => el.startTime === value)[0].endTime,
				).format('x'),
				10,
			);
			const start = parseInt(moment(value).format('x'), 10);
			const sec = moment(end, 'x').diff(moment(start, 'x'), 'seconds');
			const formatSec = moment()
				.startOf('day')
				.seconds(sec)
				.format('HH:mm:ss');
			replayTimeline = {
				start,
				end,
				sec,
				formatSec,
			};
		}
		dispatch({
			type: 'setState',
			payload: {
				replayTimeline,
				activeReplay: value,
				zonesOnStart: [],
				isEvacuationStarted: !!value,
				type: value ? 'replay' : 'evacuation',
			},
		});
	};

	const onPauseReplay = () => {
		dispatch({
			type: 'setState',
			payload: {
				isPausedReplay: true,
			},
		});
	};
	const onResumeReplay = () => {
		dispatch({
			type: 'setState',
			payload: {
				isPausedReplay: false,
			},
		});
	};

	const onSpeedChangeReplay = x => {
		const indexSpeed = speed.indexOf(x);
		const nextSpeed =
			indexSpeed >= speed.length ? speed[0] : speed[indexSpeed + 1];
		dispatch({
			type: 'setState',
			payload: {
				currentSpeed: nextSpeed || 1,
			},
		});
	};

	// @CALC DATA
	const calculateStatsFromZones = zones => {
		//  evacuationUserType :
		//  REGULAR_MOBILITY_TYPE = 0;
		//  MOBILITY_IMPAIRED_PERSONS_TYPE = 1;
		//  EMERGENCY_TYPE = 2;
		let data = zones;
		const getSumOfZones = data =>
			data.reduce((a, b) => a.concat(b.evacuationStatsItems), []);
		const sumOfZones = getSumOfZones(data);

		const countWorkingFloor = () => {
			return sumOfZones.reduce(
				(acc, zone) =>
					zone.notMovedCount ? acc + zone.notMovedCount : acc,
				0,
			);
		};

		const countEvacuationRoute = () => {
			return sumOfZones.reduce(
				(acc, zone) =>
					zone.evacuatingCount ? acc + zone.evacuatingCount : acc,
				0,
			);
		};

		const countEvacuated = () => {
			return sumOfZones.reduce(
				(acc, zone) =>
					zone.exitedCount ? acc + zone.exitedCount : acc,
				0,
			);
		};
		const totalWorkingFloor = countWorkingFloor();
		const totalEvacuationRoute = countEvacuationRoute();
		const totalEvacuated = countEvacuated();

		const employeesStart =
			totalWorkingFloor + totalEvacuationRoute + totalEvacuated;
		const employeesSave = totalEvacuated;
		const employeesRemaining = employeesStart - employeesSave;
		const evacuationProgress =
			employeesRemaining === 0
				? 100
				: Math.round((employeesSave / employeesStart) * 100 * 10) / 10;

		dispatch({
			type: 'setState',
			payload: {
				zones: data,
				employeesStart,
				employeesSave,
				employeesRemaining,
				evacuationProgress,
				numbOfEmplArr: [
					totalEvacuated,
					totalEvacuationRoute,
					totalWorkingFloor,
				],
			},
		});
	};

	const {
		sitesList,
		activeSiteId,
		activeReplay,
		isEvacuationStarted,
		evacuationStartTime,
		employeesStart,
		employeesSave,
		employeesRemaining,
		evacuationProgress,
		numbOfEmplArr,
		zones,
		zonesOnStart,
		type,
		sec,
		replayTimeline,
		isPausedReplay,
		currentSpeed,
	} = state;
	const { replays, loading } = props;
	return (
		<div className="evacuation-container">
			<EvacuationSwitchersContainer>
				<EvacuationSitesSelect
					sitesList={sitesList}
					showSearch
					onSelect={changeSite}
					onChange={changeSite}
					ant-row-flex
					placeholder="Select a site"
					optionFilterProp="children"
					defaultValue={activeSiteId}
					value={activeSiteId}
				/>
				<EvacuationReplaysSelect
					list={replays}
					showSearch
					onSelect={changeReplay}
					onChange={changeReplay}
					placeholder="Select a replay"
					optionFilterProp="children"
					defaultValue={activeReplay}
					value={activeReplay}
					disabled={isEvacuationStarted && type !== 'replay'}
				/>
				{type === 'replay' && <div className="mode">replay mode</div>}
			</EvacuationSwitchersContainer>

			<Row gutter={16} className={'top-status-bar'} type="flex">
				{isEvacuationStarted && (
					<Fragment>
						<Col md={4} xs={0} />
						<Col md={20} xs={24}>
							<EvacuationTopStatusBar
								isActive={isEvacuationStarted}
								percents={evacuationProgress}
								employeesStart={employeesStart}
								employeesSave={employeesSave}
								type={type}
							/>
						</Col>
					</Fragment>
				)}
				<Col md={4} xs={24}>
					<EvacuationButton
						isActive={isEvacuationStarted}
						toggleClick={toggleEvacuation}
						type={type}
					/>
				</Col>
				{isEvacuationStarted && (
					<Col md={20} xs={24}>
						<EvacuationProgressBarEmployees
							numbOfEmplArr={numbOfEmplArr}
						/>
					</Col>
				)}
			</Row>
			{isEvacuationStarted && (
				<Fragment>
					<EvacuationZonesContainer>
						<EvacuationZonesTable
							zones={zones}
							zonesOnStart={zonesOnStart}
							type={type}
							loading={loading}
							siteId={activeSiteId}
						/>
						<EvacuationInfo
							zones={zones}
							startTime={evacuationStartTime}
							employeesStart={employeesStart}
							employeesSave={employeesSave}
							employeesRemaining={employeesRemaining}
							type={type}
							replayTimeline={replayTimeline}
						>
							<Timer
								isTimerActive={isEvacuationStarted}
								startTime={evacuationStartTime}
								replaySec={sec}
								type={type}
							/>
						</EvacuationInfo>
						{/* <EvacuationZones */}
						{/* zones={zones} */}
						{/* zonesOnStart={zonesOnStart} */}
						{/* /> */}
					</EvacuationZonesContainer>
					<EvacuationPlayerBar
						onStart={startEvacuationReplay}
						type={type}
						replayTimeline={replayTimeline}
						now={sec}
						onPause={onPauseReplay}
						onResume={onResumeReplay}
						onChange={onChangeReplayTime}
						// onAfterChange={onResumeReplay}
						isPaused={isPausedReplay}
						onSpeed={onSpeedChangeReplay}
						currentSpeed={currentSpeed}
					/>
				</Fragment>
			)}
		</div>
	);
}
const mapStateToProps = ({ evacReplay }) => {
	return {
		replays: evacReplay.list,
		replayData: evacReplay.data,
		loading: evacReplay.loading,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		getReplayList: params => dispatch(actions.getReplayList(params)),
		getReplayData: params => dispatch(actions.getReplayData(params)),
	};
};

export default compose(
	withClientId,
	connect(
		mapStateToProps,
		mapDispatchToProps,
	),
)(EvacuationDemoDashboard);



// WEBPACK FOOTER //
// ./src/pages/evacuation-demo/evacuation-demo-dashboard/index.js